import { useMemo } from 'react';
import { useEditorVariables } from '@/blocks/application/hooks/useEditorVariables';
import type { DocumentTypeRef } from '@/document-types/domain/types/DocumentType';

export const useKnownVariablePaths = (ref?: DocumentTypeRef): ReadonlySet<string> => {
  const { categories } = useEditorVariables(ref);

  return useMemo(() => {
    const paths = new Set<string>();
    for (const category of categories) {
      for (const variable of category.variables) {
        if (variable.path) paths.add(variable.path);
      }
    }
    return paths;
  }, [categories]);
};
